import { Box, styled } from '@mui/material';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router';

import { ROUTES } from '../../../../utils/routes';
import { SupplierListItemBoxContent } from './supplier-list-item-box-content';
import { SupplierListItemBoxProps } from './supplier-list-item-box-props';

const StyledBox = styled(Box)(({ theme }) => ({
    border: `1.5px solid ${theme.palette.grey[300]}`,
    borderRadius: 4,
    width: '100%',
    padding: theme.spacing(2),
    transition: 'box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
        boxShadow: '0px 2px 14px 0px #21272E42',
        cursor: 'pointer',
    },
    [theme.breakpoints.up('sm')]: {
        height: 98,
    },
}));

export const SupplierListItemBoxAT = (props: SupplierListItemBoxProps): ReactElement => {
    const navigate = useNavigate();

    const handleClick = (): void => {
        navigate(ROUTES.supplierDirectory.detail.replace(':id', props.item.id.toString()));
    };

    return (
        <StyledBox onClick={handleClick}>
            <SupplierListItemBoxContent item={props.item} />
        </StyledBox>
    );
};
